import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MenuController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
  user;
  @Input() showBackIcon = false;
  @Input() backIconFunc;
  @Input() actualScreen = '';

  constructor(
    private router: Router,
    private location: Location,
    private menuController: MenuController,
    private authenticationService: AuthenticationService
  ) {
    this.user = this.authenticationService.userValue;
  }

  goBack() {
    if (!this.showBackIcon) {
      return;
    }
    if (this.backIconFunc) {
      this.backIconFunc();
    }
    this.location.back();
  }

  openMenu() {
    this.menuController.toggle();
  }

  goToProfile() {
    this.router.navigate(['/profile']);
  }
}
